import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { UserService } from '@core/services/user/user.service'

export const requirementsGuard: CanActivateFn = () => {
  const userService = inject(UserService)
  const router = inject(Router)

  userService.checkRequirements().subscribe(result => {
    const { allowed, redirect_page } = result

    if (!allowed) {
      router.navigate([redirect_page])
    }
  })

  return true
}
